<template>
  <div class="business-area-list-page">
    <div class="head-wrap flex-rowl">
      <div class="icon">
        <img src="../../../assets/images/business-title-icon.png" alt="" />
      </div>
      <div class="head-content">
        <h1>器材收费标准管理</h1>
        <p>器材收费设置</p>
      </div>
    </div>
    <div
      class="business-area-list"
      ref="businessAreaList"
      @scroll="handleScroll"
      v-if="dataList.length > 0 && !isLoading"
    >
      <div
        class="business-area-item flex-between"
        v-for="(item, index) in dataList"
        :key="index"
        @click="handleGoPage(item)"
      >
        <div class="business-area-content">
          <h1>{{ item.meachinename }}</h1>
          <p>收费标准：<span class="price">￥{{ item.price }}</span><span>使用收费标准/每次</span></p>
        </div>
        <div class="business-area-btn flex-rowl">
          <span class="query-icon"></span>管理
        </div>
      </div>
      <div class="common-no-more flex-rowc" v-if="hasMore">暂无更多数据...</div>
    </div>
    <!-- 加载提示 -->
    <div class="common-loading-wrap flex-rowc" v-if="isLoading">
      <van-loading type="spinner" vertical>加载中...</van-loading>
    </div>

    <div
      class="common-no-data flex-rowc"
      v-if="dataList.length == 0 && !isLoading"
    >
      <van-empty description="暂无数据" />
    </div>

    <!-- 底部 -->
    <div class="fixed-btm flex-rowc">
      <div class="return flex-rowc" @click="handleBack">返回</div>
      <!-- <div class="add-btn flex-rowc" @click="handleGoPage('add')">
        +新增记录
      </div> -->
    </div>
  </div>
</template>
  
  <script>
import { getEquipmentList } from "../../../api/api";
export default {
  name: "EquipmentChargeManagement",
  data() {
    return {
      params: {
        pageindex: 1,
        pagesize: 15,
        keyword: "",
        isuse: 1,
      },
      dataList: [], //
      totalPage: 1, // 总页数
      isLoading: true, // 是否正在加载
      hasMore: false, // 是否还有更多数据
      isLoadingMore: false, // 新增加载状态锁
    };
  },
  created() {
    this.getEquipmentList();
  },
  methods: {
    // 获取附加设备器具列表
    async getEquipmentList() {
      try {
        const res = await getEquipmentList(this.params);
        if (res.list) {
          this.dataList = this.dataList.concat(res.list);
          this.totalPage = res.total;
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isLoading = false;
      }
    },

    handleGoPage(item) {
      
      this.$router.push({
        name: "EditEquipmentCharge",
        query: { id: item.id },
      });
    },
    // 返回上一页
    handleBack() {
      this.$router.back();
    },

    // 处理滚动事件
    handleScroll() {
      const { scrollTop, scrollHeight, clientHeight } =
        this.$refs.businessAreaList;
      let { dataList, totalPage, isLoadingMore } = this;
      if (isLoadingMore || dataList.length >= totalPage) return;
      // 当滚动到底部 20px 范围内时触发加载
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.hasMore = true;
        this.params.pageindex++;
        this.isLoadingMore = true; // 开始加载，设置锁
        this.getEquipmentList().finally(() => {
          this.isLoadingMore = false; // 加载完成，释放锁
        });
      }
    },
  },
};
</script>
  
  <style scoped lang="less">
.business-area-list-page {
  box-sizing: border-box;

  .head-wrap {
    width: 700px;
    margin: auto;
    padding: 60px 0 70px 58px;
    box-sizing: border-box;
    font-size: 20px;
    color: #333333;
    .icon {
      width: 33px;
      height: 40px;
      margin-right: 24px;
    }
    h1 {
      font-size: 30px;
      margin-bottom: 7px;
    }
  }
  .business-area-list {
    width: 700px;
    margin: auto;
    height: 75vh;
    overflow-y: scroll;
    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }
    .business-area-item {
      width: 100%;
      height: 130px;
      border-radius: 60px;
      background: #fff;
      font-size: 20px;
      padding: 0 30px 0 59px;
      color: #333333;
      box-sizing: border-box;
      margin-block-start: 20px;
      cursor: pointer;
      .business-area-content {
        h1 {
          font-size: 26px;
          margin-bottom: 20px;
          font-weight: 500;
        }
        p {
          span {
            color: #ff0000;
            &.price {
              margin: 0 7px;
            }
          }
        }
      }
      .business-area-btn {
        width: 130px;
        height: 50px;
        background: #0031c9;
        border-radius: 25px;
        font-size: 22px;
        color: #ffffff;
        padding-left: 16px;
        box-sizing: border-box;
        .query-icon {
          width: 27px;
          height: 30px;
          background: url("../../../assets/images/query-icon.png") no-repeat
            center;
          background-size: cover;
          display: inline-block;
          margin-right: 4px;
          margin-right: 16px;
        }
      }
    }
  }

  .fixed-btm {
    position: fixed;
    bottom: 0;
    height: 150px;
    background: #fff;
    z-index: 10;
    align-items: flex-start;
    width: 100%;
    max-width: 750px;
    margin: auto;
    cursor: pointer;
    .return {
      font-size: 24px;
      color: #000000;
      height: 100%;
      width: 150px;
      align-items: flex-start;
      padding-top: 50px;
      box-sizing: border-box;
      margin-right: 30px;
      &::before {
        display: inline-block;
        content: "";
        background: url("../../../assets/images/return-icon.png") no-repeat
          center;
        background-size: cover;
        width: 15px;
        height: 25px;
        margin-right: 8px;
      }
    }
    .add-btn {
      width: 210px;
      height: 50px;
      background: #0031c9;
      border-radius: 25px;
      font-size: 24px;
      color: #fff;
      margin-top: 38px;
    }
  }
}
</style>